import React, { useEffect, useState } from 'react';
import { withRouter, useLocation, Link } from 'react-router-dom';
import Icon from 'Components/Icon';
import { withMixpanel } from 'Utils/mixpanel';
import PropTypes from 'prop-types';

const BreadCrumb = ({ data, mixpanel, activeTab }) => {
  const location = useLocation();
  const [breadcrumbItems, setBreadcrumbItems] = useState([]);

  useEffect(() => {
    if (!data) return;

    const normalizeSlug = str =>
      (str || '')
        .replace(/^\/lig-merkezi\//, '')
        .replace(/İ/g, 'i')
        .replace(/Ç/g, 'c')
        .replace(/Ğ/g, 'g')
        .replace(/I/g, 'i')
        .replace(/Ö/g, 'o')
        .replace(/Ş/g, 's')
        .replace(/Ü/g, 'u')
        .toLowerCase()
        .replace(/ç/g, 'c')
        .replace(/ğ/g, 'g')
        .replace(/ı/g, 'i')
        .replace(/ö/g, 'o')
        .replace(/ş/g, 's')
        .replace(/ü/g, 'u')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    const pathname = window.location.pathname;
    const pathParts = pathname.split('/').filter(Boolean);

    const items = [
      {
        label: '',
        path: '/',
        isIcon: true,
        isHomePage: true
      },
      {
        label: 'Lig Merkezi',
        path: '/lig-merkezi',
        isIcon: false
      }
    ];

    if (pathname === '/lig-merkezi/canli-yayin-rehberi') {
      items.push({
        label: 'Canlı Yayın Rehberi',
        path: pathname,
        isIcon: false,
        isLast: true
      });
      setBreadcrumbItems(items);
      return;
    }

    if (pathParts.length <= 1) {
      items[items.length - 1].isLast = true;
      setBreadcrumbItems(items);
      return;
    }

    const mainSlug = pathParts[1];
    const tabSlug = pathParts.length > 2 ? pathParts[2] : null;

    const getTabSlug = tab => normalizeSlug(tab.name || tab.widgetName || '');

    let foundLeague = null;
    let foundTeam = null;
    let widgetTabs = [];

    // eslint-disable-next-line react/prop-types
    data?.leagues?.forEach(category => {
      if (!category.leagues) return;

      category.leagues.forEach(league => {
        const leagueSlug = league.slug || '';

        if (leagueSlug === mainSlug || normalizeSlug(leagueSlug) === normalizeSlug(mainSlug)) {
          foundLeague = league;
          if (league.widgets) {
            widgetTabs = league.widgets;
          }
        }

        if (league.teams) {
          league.teams.forEach(team => {
            const teamSlug = team.slug || '';

            if (teamSlug === mainSlug || normalizeSlug(teamSlug) === normalizeSlug(mainSlug)) {
              foundTeam = team;
              foundLeague = league;
              if (team.widgets && team.widgets.length > 0) {
                widgetTabs = team.widgets;
              } else if (league.widgets) {
                widgetTabs = league.widgets;
              }
            }
          });
        }
      });
    });

    if (tabSlug && widgetTabs.length > 0) {
      const foundWidget = widgetTabs.find(tab => getTabSlug(tab) === normalizeSlug(tabSlug));

      if (foundWidget) {
        let entityName = '';
        if (foundTeam) {
          entityName = foundTeam.teamName || foundTeam.title;
        } else if (foundLeague) {
          entityName = foundLeague.leagueName || foundLeague.title;
        }
        items.push({
          label: `${entityName} ${foundWidget.name}`,
          path: pathname,
          isIcon: false,
          isLast: true
        });
        setBreadcrumbItems(items);
        return;
      }
    }

    if (foundTeam) {
      items.push({
        label: foundTeam.teamName || foundTeam.title,
        path: `/lig-merkezi/${mainSlug}`,
        isIcon: false,
        isLast: true
      });
    } else if (foundLeague) {
      items.push({
        label: foundLeague.leagueName || foundLeague.title,
        path: `/lig-merkezi/${mainSlug}`,
        isIcon: false,
        isLast: true
      });
    }

    if (items.length > 0 && !items.some(item => item.isLast)) {
      items[items.length - 1].isLast = true;
    }

    setBreadcrumbItems(items);
  }, [data, location.pathname]);

  // Aktif tabı sona ekle
  let finalBreadcrumbItems = breadcrumbItems;
  if (activeTab && finalBreadcrumbItems.length > 0) {
    // Eğer son kırılım 'Canlı Yayın Rehberi' ise, label ile birleştir
    const last = finalBreadcrumbItems[finalBreadcrumbItems.length - 1];
    if (last.label === 'Canlı Yayın Rehberi') {
      finalBreadcrumbItems = [
        ...finalBreadcrumbItems.slice(0, -1),
        { ...last, label: `${last.label} ${activeTab}` }
      ];
    } else {
      finalBreadcrumbItems = [
        ...finalBreadcrumbItems,
        { label: activeTab, isIcon: false, isLast: true }
      ];
    }
  }

  return (
    <div className="breadcrumb">
      <div className="breadcrumb-content">
        { finalBreadcrumbItems.map((item, index) => {
          const isLast = index === finalBreadcrumbItems.length - 1 || item.isLast;

          return (
            <React.Fragment key={ `breadcrumb-${index}` }>
              { index > 0 && <Icon iconName="svgArrowRightTheme" className="arrow" /> }

              { /* eslint-disable-next-line no-nested-ternary */ }
              { item.isIcon ? (
                <Link
                  to={ item.path }
                  onClick={ () => {
                    mixpanel.track('Click League Center Breadcrumb', {
                      'Page Name': item?.path === '/' && 'Anasayfa',
                      source: 'breadcrumb',
                    });
                  } }
                >
                  <Icon iconName="svgBilyoner" className="home-icon" />
                </Link>
              ) : isLast ? (
                <h1 className="breadcrumb-item active">{ item.label }</h1>
              ) : (
                <Link
                  className="breadcrumb-item"
                  to={ item.path }
                  onClick={ () => {
                    mixpanel.track('Click League Center Breadcrumb', {
                      'Page Name': item?.path,
                      source: 'breadcrumb',
                    });
                  } }
                >
                  <span >{ item.label }</span>
                </Link>
              ) }
            </React.Fragment>
          );
        }) }
      </div>
    </div>
  );
};

BreadCrumb.propTypes = {
  data: PropTypes.object.isRequired,
  mixpanel: PropTypes.object,
  activeTab: PropTypes.string
};

export default withRouter(withMixpanel(BreadCrumb));
